import { useState, useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { deleteRole } from '../api'
import { toast } from '@sales-center/components'

export const useDeleteRole = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const [toDelete, setToDelete] = useState<number>()

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      if (toDelete) {
        try {
          setStatus('pending')
          const result = await dispatch(deleteRole(toDelete))
          if (mounted) {
            if (deleteRole.fulfilled.match(result)) {
              setStatus('success')
              toast.success('Role deleted successfully.')
            } else {
              setStatus('fail')
              toast.error('Failed to delete role.')
            }
          }
        } catch {
          if (mounted) setStatus('fail')
          toast.error('Failed to delete role.')
        } finally {
          if (mounted) {
            setStatus('idle')
            setToDelete(undefined)
          }
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, toDelete])

  return { status, execute: setToDelete }
}
